import { forwardRef } from 'react';
import { Input, ErrorMessage, RightIconContainer, FormInputContainer } from './Input.style';
import { ErrorSolidIcon } from '@icons';
import { InputHTMLAttributes } from 'react';
import { FormLabel } from '..';

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  errorText?: string;
  label?: string;
  rightIcon?: React.ReactNode;
  rightIconClick?: () => void;
  tooltip?: {
    title: string;
    content: string;
  };
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ errorText, label, tooltip, rightIcon, rightIconClick, ...props }, ref) => {
    return (
      <FormInputContainer>
        {label && (
          <FormLabel htmlFor={props.id} tooltip={tooltip}>
            {label}
          </FormLabel>
        )}
        {rightIcon && <RightIconContainer onClick={rightIconClick}>{rightIcon}</RightIconContainer>}
        <Input {...props} ref={ref} hasError={!!errorText} />
        {errorText && (
          <ErrorMessage>
            <ErrorSolidIcon /> <span>{errorText}</span>
          </ErrorMessage>
        )}
      </FormInputContainer>
    );
  }
);

FormInput.displayName = 'FormInput';

export default FormInput;
